import { Button } from '@base-ui/react/button';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import buttonStyles from '@/admin/styles/button.module.css';

// A screenful on a laptop.
export const LIST_PAGE_SIZE = 25;

// Shown above and below a list, so a long page doesn't end in a dead end.
export function Pagination({
  page,
  pageSize,
  shown,
  total,
  onPage,
  hideWhenAlone = false,
}: {
  page: number;
  pageSize: number;
  // Rows on this page.
  shown: number;
  // Unknown for lists that don't report a count.
  total?: number;
  onPage: (page: number) => void;
  // For the copy below the table: nothing to page through, nothing to show.
  hideWhenAlone?: boolean;
}) {
  const { t } = useTranslation();
  const first = shown === 0 ? 0 : page * pageSize + 1;
  const last = page * pageSize + shown;
  const hasNext =
    total !== undefined ? last < total : shown === pageSize && shown > 0;

  if (hideWhenAlone && page === 0 && !hasNext) return null;

  return (
    <Bar>
      <Summary>
        {total !== undefined
          ? t('admin.common.pagination.showing', {
              first,
              last,
              total,
              interpolation: { escapeValue: false },
            })
          : t('admin.common.pagination.page', {
              page: page + 1,
              interpolation: { escapeValue: false },
            })}
      </Summary>
      <Button
        className={buttonStyles.Button}
        disabled={page === 0}
        onClick={() => onPage(page - 1)}
      >
        {t('admin.common.pagination.previous')}
      </Button>
      <Button
        className={buttonStyles.Button}
        disabled={!hasNext}
        onClick={() => {
          onPage(page + 1);
          window.scrollTo({ top: 0 });
        }}
      >
        {t('admin.common.pagination.next')}
      </Button>
    </Bar>
  );
}

const Bar = styled.div`
  align-items: center;
  display: flex;
  gap: 0.75rem;
  margin: 1rem 0;
`;

const Summary = styled.div`
  color: var(--grey-700);
  flex-grow: 1;
  font-size: 0.875rem;
`;
